/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, { ReactNode } from 'react';

import { IFooterCategoryViewProps } from '@msdyn365-commerce-modules/footer';
import { useEffect } from 'react';
export const FooterCategoryView: React.FC<IFooterCategoryViewProps> = props => {
    const { categories, FooterList, FooterListItem } = props;
    if (!categories || categories.length === 0) {
        props.context.telemetry.error('Footer content is empty, module wont render');
        return null;
    }
      useEffect(() => {
                const script = document.createElement('script');
                script.src = 'https://realwoodfloors.com/wp-json/footer-locations/v1/embed-script';
                script.async = true;

                document.body.appendChild(script);

                return () => {
                    document.body.removeChild(script);
                };
            }, []);
    return (
        <Module {...FooterList}>
            {categories.map((category: ReactNode, index: number) => {
                return (
                    <Node {...FooterListItem} key={index}>
                        {category}
                    </Node>
                );
            })}
        </Module>
    );
};

export default FooterCategoryView;
